import { ExpedientFormData } from '@/containers/logistic/expedients/wizzardExpedient/ExpedientWizard'
import query from './APIServices'
import { ModuleCode } from '@/interfaces/ServerInterfaces'

export interface Package {
  id: number
  name: string
  code: ModuleCode
  isActive: boolean
  isSensitive: boolean
}

export const getAllPackages = async () => {
  const response = await query.get('/administration/business/packages')
  return response.data as Package[]
}
